/**
 * FixSessionPage — standalone page for provenance spellcheck review.
 *
 * Opened by the Python SDK via `webbrowser.open()`. Fetches the fix
 * session from the API and renders the review UI.
 */

import { useParams } from "react-router-dom";
import { Box, Heading, Spinner, Text } from "@radix-ui/themes";

import { useFixSession } from "../hooks/useFixSession";
import FixReview from "../components/fix/FixReview";

export default function FixSessionPage() {
  const { sessionId } = useParams<{ sessionId: string }>();
  const { data, isLoading, error } = useFixSession(sessionId!);

  if (isLoading) {
    return (
      <Box
        p="6"
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
          background: "#1e1e1e",
        }}
      >
        <Spinner size="3" />
        <Text mt="3" style={{ color: "#6a737d" }}>
          Loading provenance review...
        </Text>
      </Box>
    );
  }

  if (error || !data) {
    return (
      <Box
        p="6"
        style={{
          maxWidth: 600,
          margin: "0 auto",
          paddingTop: 80,
          background: "#1e1e1e",
          minHeight: "100vh",
        }}
      >
        <Heading size="4" color="red" mb="2">
          Session Not Found
        </Heading>
        <Text style={{ color: "#6a737d" }}>
          This fix session may have expired or already been completed.
        </Text>
      </Box>
    );
  }

  return <FixReview session={data} />;
}
